/* My Acre pond picker (2026-09-17, Claude). Behaviour for sections/ma-pond-picker.liquid.

   The recommendation table is below. Each entry is [handle, variant, what it fits].
   The variant is either an exact variant title, or 'cheapest' / 'dearest' for a kit whose
   variants ARE its tiers, so the mid and top labels always match the real price order rather
   than a guess about which option is which. Products missing from the data (not published)
   are skipped. Nothing here states a price or a warranty: both come from the product. */
(function () {
  var REC = {
    pond: {
      xs: [['oase-preformed-pond-shell', '500 L', 'A 1.78 by 1.26 m preformed shell, no liner needed'],
           ['aquascape-diy-backyard-pond-kit', '1.2m x 1.8m', 'A 1.2 by 1.8 m lined pond with filtration']],
      s:  [['aquascape-diy-backyard-pond-kit', '2.4m x 3.3m', 'A 2.4 by 3.3 m lined pond you install yourself'],
           ['aquascape-small-pond-kit-2-4m-x-3-3m', 'Default Title', 'A 2.4 by 3.3 m pond kit']],
      m:  [['aquascape-medium-pond-kit-3-3m-x-4-8m', 'cheapest', 'A 3.3 by 4.8 m pond'],
           ['aquascape-medium-pond-kit-3-3m-x-4-8m', 'dearest', 'A 3.3 by 4.8 m pond']],
      l:  [['aquascape-large-pond-kit-6-4m-x-7-9m', 'cheapest', 'A 6.4 by 7.9 m pond'],
           ['aquascape-large-pond-kit-6-4m-x-7-9m', 'dearest', 'A 6.4 by 7.9 m pond']]
    },
    pondless: {
      xs: [['aquascape-diy-backyard-waterfall-kit', 'Default Title', 'A compact first waterfall'],
           ['aquascape-backyard-waterfall-landscape-fountain-kit', 'Default Title', 'A spill wall or short rock fall']],
      s:  [['aquascape-diy-backyard-waterfall-kit', 'Default Title', 'A compact first waterfall'],
           ['aquascape-small-pondless-waterfall-kit-2m-stream', 'Default Title', 'A 2 m stream with a waterfall']],
      m:  [['aquascape-medium-pondless-waterfall-kit-5m-stream', 'cheapest', 'A 5 m stream with a waterfall'],
           ['aquascape-medium-pondless-waterfall-kit-5m-stream', 'dearest', 'A 5 m stream with a waterfall']],
      l:  [['aquascape-large-pondless-waterfall-kit-8m-stream', 'cheapest', 'An 8 m stream with a waterfall'],
           ['aquascape-large-pondless-waterfall-kit-8m-stream', 'dearest', 'An 8 m stream with a waterfall']]
    },
    swim: [['aquascape-recreation-pond-kit-7m-x-5m', 'cheapest', 'A 7 by 5 m swimmable pond'],
           ['aquascape-recreation-pond-kit-7m-x-5m', 'dearest', 'A 7 by 5 m swimmable pond']]
  };

  var TREES_WHY = 'Leaves that land in an open pond sink and rot, which feeds algae and means netting ' +
    'and vacuuming every autumn. A pondless waterfall keeps its water in a basin under the gravel, ' +
    'so leaves sit on stone where you can rake them off. You still get the sound and the movement.';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function boot() {
    var root = document.querySelector('[data-ma-pp]');
    if (!root || root.dataset.maPpBound) return;
    root.dataset.maPpBound = '1';
    var dataEl = document.querySelector('[data-ma-pp-data]');
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-ma-pp-form]');
    var out = root.querySelector('[data-ma-pp-out]');

    function pick(handle, vname) {
      var p = D.products[handle];
      if (!p) return null;
      var names = Object.keys(p.variants);
      var name = vname;
      if (vname === 'cheapest' || vname === 'dearest') {
        var priced = names.filter(function (n) { return p.variants[n].cents > 0; });
        if (!priced.length) { name = names[0]; }
        else {
          priced.sort(function (a, b) { return p.variants[a].cents - p.variants[b].cents; });
          name = vname === 'cheapest' ? priced[0] : priced[priced.length - 1];
        }
      }
      var v = p.variants[name];
      if (!v) return null;
      return { handle: handle, p: p, name: name, v: v };
    }

    function card(entry, tier) {
      var r = pick(entry[0], entry[1]);
      if (!r) return '';
      var here = r.handle === D.current;
      var variantLine = r.name && r.name !== 'Default Title' ? '<span class="ma-pp__var">' + esc(r.name) + '</span>' : '';
      var price = r.v.price ? esc(r.v.price) : 'Price on request';
      var link = here
        ? '<span class="ma-pp__here">You are looking at this one</span>'
        : '<a class="ma-pp__go" href="' + esc(r.p.url) + '?variant=' + r.v.id + '">See it</a>';
      return '<article class="ma-pp__card' + (here ? ' is-here' : '') + '">' +
        '<p class="ma-pp__tier">' + tier + '</p>' +
        '<h3 class="ma-pp__name">' + esc(r.p.title) + '</h3>' + variantLine +
        '<p class="ma-pp__fits"><b>Fits:</b> ' + esc(entry[2]) + '</p>' +
        (r.p.warranty ? '<p class="ma-pp__war"><b>Warranty:</b> ' + esc(r.p.warranty) + '</p>' : '') +
        '<p class="ma-pp__price">' + price + '</p>' + link +
        '</article>';
    }

    function pair(list) {
      if (!list) return '';
      var html = card(list[0], 'Mid tier') + card(list[1], 'Top tier');
      return html ? '<div class="ma-pp__grid">' + html + '</div>' : '';
    }

    function val(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function render() {
      var goal = val('ma-pp-goal'), over = val('ma-pp-over'), room = val('ma-pp-room');
      if (!goal || !over || !room) { out.innerHTML = ''; return; }
      var html = '';
      if (goal === 'pond' && over === 'trees') {
        html += '<div class="ma-pp__advice"><h3>With trees overhead, we would look at a pondless waterfall first</h3>' +
          '<p>' + TREES_WHY + '</p></div>' + pair(REC.pondless[room]) +
          '<button type="button" class="ma-pp__more" data-ma-pp-anyway>Show me the ponds anyway</button>' +
          '<div data-ma-pp-ponds hidden>' + pair(REC.pond[room]) + '</div>';
      } else if (goal === 'swim') {
        if (room !== 'l') {
          html += '<div class="ma-pp__advice"><p>A swimmable pond needs about 7 by 5 m of level ground. ' +
            'Worth measuring again before going further.</p></div>';
        }
        if (over === 'trees') {
          html += '<div class="ma-pp__advice"><p>Leaf fall adds cleaning to any open water. The wetland ' +
            'zone does much of the work, but plan on skimming through autumn.</p></div>';
        }
        html += pair(REC.swim);
      } else {
        html += pair(REC[goal][room]);
      }
      if (!html || html.indexOf('ma-pp__card') === -1) {
        html = '<div class="ma-pp__advice"><p>Nothing in the range matches that exactly. Call us on ' +
          '<a href="tel:1300515620">1300 515 620</a> and we will work it out with you.</p></div>';
      }
      out.innerHTML = html;
      var btn = out.querySelector('[data-ma-pp-anyway]');
      if (btn) btn.addEventListener('click', function () {
        var box = out.querySelector('[data-ma-pp-ponds]');
        if (box) box.hidden = false;
        btn.hidden = true;
      });
    }

    form.addEventListener('change', render);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();